import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { customerLicense, setDomainLicenseUrl } from '../Store/actions/customerInfoActions';

const useCustomerLicenseFetch = (contextData: any, reload: any, urls?: any) => {
    const CIP_DOMAIN = urls?.CIP_DOMAIN;
    const { ocPlatformData: {
        chatInfo: { contactId : platFormContactId = '', currentContactId : platFormCurrentContactId = '' } = {} } = {},ocAppData, jcAuthData } = contextData;
    const { modifiedCustomer: { email: modifiedEmail = '', contactId = '' } = {} } = ocAppData || {};
    const {email: authEmail = ''} = jcAuthData || {};
    const email = modifiedEmail || authEmail;
    const dispatch = useDispatch();
    const fallbackcontactId = platFormContactId || platFormCurrentContactId;
    const { currentContactId }: any = useSelector((state: any) => state.customerInfo);
    const ENABLE_DOMAIN_LICENSE: Boolean = JSON.parse(localStorage.getItem('fastFollowFlags')).ENABLE_DOMAIN_LICENSE;
    useEffect(() => {
        let isMounted = true;
        const source = axios.CancelToken.source();
        const customConversationId = currentContactId || contactId || fallbackcontactId;
        
        // Initialize domain license URL state as null
        dispatch(setDomainLicenseUrl(null));
        
        if (isMounted && email && ENABLE_DOMAIN_LICENSE) {
            const fetchData = async (url: any, email: any) => {
                const domain = email ? email.split('@')[1] : '';
                if(!domain) return;
                dispatch(customerLicense({ loading: true, data: [] }));
                console.log('CIP : Fetching Customer License Count for domain', email);
                try {
                    const lisenceCountResponse: any = await axios.get(
                        `${url}/api/v1/customer/license?domain=${domain}&conversationId=${customConversationId}`,
                        {
                            headers: { 'x-api-key': 'oac-custom-panel', Authorization: localStorage.getItem('customPanelAccessToken').replaceAll('"', '') ?? '' },
                            cancelToken: source.token,
                        },
                    );
                    const summary = lisenceCountResponse?.data?.json?.length ?  lisenceCountResponse.data.json : [];
                    dispatch(customerLicense({ loading: false, data: summary }));
                    
                    // Determine which URL to use based on API response
                    let urlToSet = null;
                    const responseData = lisenceCountResponse?.data;
                    
                    if (responseData && responseData.json && responseData.json.length > 0 && responseData.success === true) {
                        // Replace [INSERT-EMAIL-DOMAIN] with domain
                        urlToSet = urls?.DOMAIN_LICENSE_DETAILS_URL?.replace('[INSERT-EMAIL-DOMAIN]', domain);
                    } else if (responseData && responseData.json && responseData.json.message === "Domain is excluded from processing") {
                        // Replace [INSERT-EMAIL] with email
                        urlToSet = urls?.DOMAIN_LICENSE_DETAILS_URL_EXCLUDED?.replace('[INSERT-EMAIL]', email);
                    } else {
                        // Use unauth URL for any other case
                        urlToSet = urls?.DOMAIN_LICENSE_DETAILS_URL_UNAUTH;
                    }
                    
                    dispatch(setDomainLicenseUrl(urlToSet));
                } catch (error) {
                    if (isMounted) {
                        dispatch(customerLicense({ loading: false, data: [] }))
                        dispatch(setDomainLicenseUrl(urls?.DOMAIN_LICENSE_DETAILS_URL_UNAUTH || null));
                        console.log('CIP : Exception in Customer License Count API call', error);
                    }
                } finally {
                    setTimeout(() => {
                        (window as any).enable_CIP = false;
                    }, 100);
                }
            };
            fetchData(CIP_DOMAIN, email);
        } else if (isMounted) {
            dispatch(customerLicense({ loading: false, data: [] }));
            // Set unauth URL when condition doesn't pass
            dispatch(setDomainLicenseUrl(urls?.DOMAIN_LICENSE_DETAILS_URL_UNAUTH || null));
        }

        return () => {
            isMounted = false;
            source.cancel();
        };
    }, [email, reload, fallbackcontactId]);
};

export default useCustomerLicenseFetch;
